// extracted by mini-css-extract-plugin
export default {"container":"Yt2FcJ"};